import React, { useRef, useEffect } from 'react';
import { Button, ButtonProps } from '../button/Button';
import { ButtonSize } from '../button/types';

export type ModalActionButtonType = 'confirm' | 'cancel';

export const ModalActionButton: React.FC<ButtonProps> = (props) => {
  const actionButtonRef = useRef<HTMLButtonElement>(null);
  const modifiedProps = {
    size: 'large' as ButtonSize,
    ...props,
    ref: actionButtonRef,
  };

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | number | null = null;
    if (props.autoFocus) {
      timeoutId = setTimeout(() => {
        actionButtonRef.current?.focus({ preventScroll: true });
      });
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [props.autoFocus]);

  return <Button {...modifiedProps}>{props.children}</Button>;
};
